<template>
    <section>
        <div class="py-5">
            <div class="container">

                <!-- Status Header -->
                <div class="row">
                    <div :class="[
                        'col-12 mb-2 text-center',
                        ResponseStatus === 400 || RequestCode === 'REJECTED'
                            ? 'final_step_error'
                            : 'final_step'
                    ]">
                        <i :class="iconClass"></i>
                        <h2 class="blueFont">{{ RequestStatus }}</h2>
                    </div>
                </div>

                <!-- Request Id -->
                <div class="row justify-content-center">
                    <div class="col-12 col-md-4 text-center">
                        <p class="fw-bold">رقم الطلب: {{ requestId }}</p>
                    </div>
                </div>

                <!-- Review Title -->
                <div v-if="isReview" class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont">مراجعة حالة الطلبات</h2>
                    </div>
                </div>

                <!-- Loading State -->
                <div v-if="isLoading" class="row justify-content-center my-4">
                    <div class="col-12 text-center text-muted">
                        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                        جارٍ تحميل بيانات الطلب...
                    </div>
                </div>

                <!-- Documents Table -->
                <template v-else-if="isReview">

                    <!-- Has documents -->
                    <div v-if="hasDocuments" class="row my-3">
                        <div class="table-responsive">
                            <table class="table table-hover table-borderless">
                                <thead>
                                    <tr class="text-center">
                                        <th width="10%">نوع الوثيقة</th>
                                        <th width="20%">حالة الطلب</th>
                                        <th width="70%">سبب الرفض</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="group in documents" :key="group.label">
                                        <tr v-for="doc in group.list" :key="doc.Id" class="text-center">
                                            <td>{{ group.label }}</td>
                                            <td>{{ doc.State?.CodeMessage }}</td>
                                            <td>{{ doc.RejectionReason?.Name || NullRejectionReason }}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- No documents -->
                    <div v-else class="row justify-content-center my-4">
                        <div class="col-12 col-md-6 text-center text-muted">
                            <i class="bi bi-folder2-open" style="font-size: 2.5rem;"></i>
                            <p class="mt-2">لا توجد وثائق مرتبطة بهذا الطلب حالياً.</p>
                        </div>
                    </div>

                </template>

                <!-- Fawry Payment -->
                <div v-if="showfawry" class="row my-4 justify-content-center">
                    <div class="col-12 col-sm-4 mb-3">
                        <div class="d-flex justify-content-center">
                            <a :href="fawryUrl" target="_blank">
                                <img src="@/assets/images/atfawry-ar-logo-new.png" class="img-fluid" />
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Close Button -->
                <div class="row my-4 justify-content-center">
                    <div class="col-12 col-sm-4 mb-3">
                        <div class="d-flex justify-content-center">
                            <button @click="ToMainPage" type="button" class="btn btn-light mx-3 align-self-center">
                                غلق
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import { debugError, debugLog } from "@/plugins/debug";
export default {

    name: "InqResComp",

    data() {
        return {
            RequestStatus: "",
            RequestCode: "",
            ResponseStatus: 0,

            Details: null,

            NullRejectionReason: " ",

            isLoading: true,
            isReview: true,
            showfawry: false,

            fawryUrl: ""
        };
    },

    computed: {

        requestId() {
            return this.$route.params.req_id;
        },

        iconClass() {

            if (this.ResponseStatus === 400)
                return "bi bi-exclamation-circle-fill";

            if (this.RequestCode === "REJECTED")
                return "bi bi-x-circle-fill";

            if (
                ["PAYMENT_ACCEPTED", "INTRANSIT"].includes(
                    this.RequestCode
                )
            )
                return "bi bi-check-circle-fill";

            return "bi bi-search";
        },

        hasDocuments() {
            return this.documents.some(g => g.list.length > 0);
        },

        documents() {

            if (!this.Details) return [];

            return [
                { label: "وثيقة ميلاد", list: this.Details.BirthDocs || [] },
                { label: "قيد وفاه", list: this.Details.DeathDocs || [] },
                { label: "وثيقة زواج", list: this.Details.MarriageDocs || [] },
                { label: "وثيقة طلاق", list: this.Details.DivorceDocs || [] },
                { label: "بطاقة الرقم القومى", list: this.Details.NidDoc || [] },
                { label: "قيد عائلى", list: this.Details.FamilyRecords || [] },
                { label: "قيد فردى", list: this.Details.PersonalRecords || [] },
                { label: "وثيقة مترجمة", list: this.Details.TranslatedDocs || [] }
            ];
        }

    },

    watch: {

        "$route.params.req_id": {
            immediate: true,
            handler() {
                this.init();
            }
        },

        RequestCode(newValue) {

            if (newValue === "WAITING_APPROVAL") {
                this.isReview = false;
            }

            if (newValue === "WAITING_PAYMENT") {
                this.showfawry = true;
                this.get_inquiryStatus();
            }

            if (newValue === "REJECTED") {
                this.isReview = true;
            }
        }

    },

    mounted() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },

    methods: {

        init() {
            window.scrollTo({ top: 0, behavior: "smooth" });
            this.get_inquiryStatusDetails();
        },

        ToMainPage() {
            this.$router.push({ name: "dashboard" });
        },

        async get_inquiryStatusDetails() {

            this.isLoading = true;

            try {

                debugLog("Request Id", this.requestId);
                const res =
                    await this.$api.requests.RequestStatus(
                        this.requestId.toString()
                    );

                if (!res) return;

                debugLog(
                        "====Get Inquiries Details Response========",
                        res
                    );
                

                this.Details = res.data;
                this.ResponseStatus = 200;

                this.RequestStatus = res.data.StateMessage;
                this.RequestCode = res.data.State.CodeMessage;

            } catch (error) {

                if (error?.response?.status === 400) {

                    this.isReview = false;

                    this.ResponseStatus = 400;

                    this.RequestStatus =
                        error.response.data.ResponseMessage;
                }

                debugError(error);

            } finally {
                this.isLoading = false;
            }

        },

        async get_inquiryStatus() {

            try {

                const res =
                    await this.$api.requests.InquireRequestStatus(
                        this.requestId.toString()
                    );

                debugLog(
                        "====Get Inquiries Response========",
                        res
                    );
                this.fawryUrl = res.data.fawryUrl;

            } catch (err) {

                debugError(err);

            }

        }

    }

};
</script>